/**
 * @author Alejandro
 * @description Filter a goal play list by location and result and time section.
 * @param {Array} goalPlayList - The play list to filter
 * @param {number} selectedLocation - The selected location in filter component
 * @param {Array<number>} selectedResults - The selected results in filter component
 * @param {Array<number>} selectedSections - The selected time sections in filter component
 * @param {Array<number>} selectedGamesIds - The selected games
 * @param {Object} playValuesIndex - Contains index position for the play values
 * @return {Array} - The filtered play list
 */
export function getSoccerGoalData(
  goalPlayList,
  selectedLocation,
  selectedResults,
  selectedSections,
  selectedGamesIds,
  playValuesIndex,
) {
  return goalPlayList.filter(play => {
    return (
      (!selectedLocation || selectedLocation === play[playValuesIndex.playingAs]) &&
      selectedResults.includes(play[playValuesIndex.matchResult]) &&
      selectedSections.includes(play[playValuesIndex.section]) &&
      selectedGamesIds.includes(play[playValuesIndex.gameId])
    );
  });
}
